import { z } from 'zod';

export const deleteEndpoint = (userId: number) => {
  return {
    endpoint: `/users/${userId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
